<!-- DOCUMENT -->
<template>
    <div>
        <!-- // * CONTENT TITLE (CUSTOM) -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center">
                    <span v-if="form[collectionItem + 'Name'] === ''" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    <span v-else class="pl-2 d-inline-block text-truncate">{{ form[collectionItem + 'Name'] }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
            <!-- ACTION BAR BUTTONS (CUSTOM) -->
			<div v-if="['SM', 'SA', 'DA'].includes(GET_currentUser.userLevel)" class="d-flex align-center">
                <appbutton :label="$t('buttons.reject')"  v-if="formMode === 'View' && ((form.documentStatus === 'PENDING') || (form.documentStatus === 'DRAFT'))" icon="icons8-high-importance" type="warning" class="mr-1" @click.native="updateItemStatus('REJECTED')" showlabel="xlOnly" />
                <appbutton :label="$t('buttons.approve')" v-if="formMode === 'View' && ((form.documentStatus === 'PENDING') || (form.documentStatus === 'DRAFT'))" icon="icons8-checkmark-yes" type="success" class="mr-2" @click.native="updateItemStatus('APPROVED')" showlabel="xlOnly" />
                <appbutton :label="$t('buttons.restore')" v-if="formMode === 'View' && form.documentStatus === 'REJECTED' && ['SM'].includes(GET_currentUser.userLevel)" icon="icons8-checkmark-yes" type="info" class="mr-2" @click.native="updateItemStatus('APPROVED')" showlabel="xlOnly" />
            </div>
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT -->
        <v-container fluid class="pa-0"  >
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU (CUSTOM) -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#viewer" class="white" :disabled="form.fileData === null"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.viewer.tabName`) }}</span></v-tab>
                            <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab>
                            <v-tab href="#history" class="white"><v-icon class="mr-2">icons8-chat-messages</v-icon> <span class="caption">{{ $t(`${langPath}.history.tabName`) }}</span></v-tab>                        
                        </v-tabs>         
                        <!-- // * TABS ITEMS -->                        
                        <v-tabs-items v-model="tabs" class="full-height-tab appbackground">
                            <!-- VIEWER -->
                            <v-tab-item value="viewer" class="ma-0 pa-0">
                                <docviewer></docviewer>
                            </v-tab-item>
                            <!-- OVERVIEW -->
                            <v-tab-item value="overview" class="pa-0">
                                <pre>Form Mode: {{ formMode }}</pre>
                                <v-row class="mt-4 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text class="tab-text" v-if="formMode === 'New' && GET_help && GET_currentUser.userType === 'CONTRACTOR'" v-html="$t(`${langPath}.overview.text.contractor`)"></app-text>
                                                <app-text class="tab-text" v-if="formMode === 'New' && GET_help && GET_currentUser.userType !== 'CONTRACTOR'" v-html="$t(`${langPath}.overview.text.default`)"></app-text>        
                                                <app-text class="tab-text" v-if="formMode !== 'New' && GET_help && ((form.documentStatus === 'PENDING') || (form.documentStatus === 'DRAFT'))&& GET_currentUser.userType !== 'CONTRACTOR'" v-html="$t(`${langPath}.overview.text.pending`)"></app-text>                                          
                                                <app-text class="tab-text" v-if="formMode !== 'New' && GET_help && ((form.documentStatus === 'APPROVED'))" v-html="$t(`${langPath}.overview.text.approved`)"></app-text>                                          
                                                <app-text class="tab-text" v-if="formMode !== 'New' && GET_help && ((form.documentStatus === 'REJECTED'))" v-html="$t(`${langPath}.overview.text.rejected`)"></app-text>                                         
                                                <app-text class="tab-text" v-if="formMode !== 'New' && GET_help && ((form.documentStatus === 'DRAFT')) && GET_currentUser.userType === 'CONTRACTOR'" v-html="$t(`${langPath}.overview.text.contractor.draft`)"></app-text>                                           
                                                <app-text class="tab-text" v-if="formMode !== 'New' && GET_help && ((form.documentStatus === 'PENDING')) && GET_currentUser.userType === 'CONTRACTOR'" v-html="$t(`${langPath}.overview.text.contractor.pending`)"></app-text>                                           
                                                <v-divider class="my-4"/>
                                            </v-col>
                                            <!-- // * ACTION BAR -->
                                            <v-col class="pa-0 d-flex pl-1 pr-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t(`buttons.destroy`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-fire" type="purple"  class="mr-1" @click.native="destroyItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && form.delete !== undefined" icon="icons8-process" type="purple"  class="mr-1" @click.native="undeleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(form.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New'" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                                                <v-spacer />
                                                <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                                                <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" @click.native="validateForm()" showlabel="xlOnly" />                                                
                                            </v-col>                    
                                        </v-row>
                                        <!-- // * FORM -->
                                        <v-form ref="form"  >
                                        <v-row class="mt-4 ma-0 px-1" no-gutters>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="16" xl="6">
                                                <v-text-field color="black" :label="$t('fields.name')" v-model="form.documentName" :rules="rules.documentName" required filled hide-details="auto" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }"></v-text-field>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label="$t('fields.type')" v-model="form.documentType" :rules="rules.documentType" required :items="documentTypes" item-value="value" dense filled hide-details="auto" :background-color="formBackground" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly }">
                                                    <template v-slot:item="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                    <template v-slot:selection="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <v-textarea color="black"  :label="$t('fields.description')" v-model="form.documentDescription" :rules="rules.documentDescription" required filled hide-details="auto" :background-color="formBackground" dense auto-grow rows="1" :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ 'disabled': formReadOnly}"></v-textarea>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="form.fileData !== null">
                                                <div class="d-flex align-center" style="width: 100% !important;">
                                                    <div style="width: 100% !important;"><v-text-field color="black" :label="$t('fields.file')" v-model="form.fileData.fileName"  filled hide-details="auto" :background-color="formBackground" :readonly="true" :class="{ 'disabled': true }"></v-text-field></div>
                                                    <div class="ml-4"><appbutton :label="$t(`buttons.removeFile`)" v-if="formMode !== 'New' && form.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="destroyFile()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/></div>
                                                </div>
                                            </v-col>
                                            <v-col class="my-2 pa-1 pr-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="form.fileData === null && formMode !== 'New'">
                                                <div class="d-flex align-center" style="width: 100% !important;">
                                                    <div style="width: 100% !important;"><v-text-field color="black" :label="$t('fields.file')" filled hide-details="auto" :background-color="formBackground" :readonly="true" :class="{ 'disabled': true }"></v-text-field></div>
                                                    <div class="ml-4 mr-0" v-if="formMode === 'View'"><docuploadbutton  :allowedtypes="allowedTypes" :doclink="docLink" :folder="folder" /></div>
                                                </div>
                                            </v-col>
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                                <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" v-if="['SA'].includes(GET_currentUser.userLevel)" color="black"  :label="$t(`fields.status`)" v-model="form.documentStatus" :items="documentStatus" filled hide-details="auto" :rules="rules.status" :background-color="formBackground" dense :clearable="!formReadOnly" :readonly="formReadOnly" :class="{ disabled: formReadOnly }">
													<template v-slot:item="data">{{ data.item.text }}</template>
													<template v-slot:selection="data">{{ data.item.text }}</template>
												</v-select>
                                                <v-text-field v-else color="black" :label="$t('fields.status')" v-model="form.documentStatus" filled hide-details="auto" :rules="rules.documentStatus"  :background-color="formBackground" dense :readonly="true" :class="{ disabled: true }"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <!-- <pre>{{ form }}</pre> -->
                                            </v-col>
                                            <!-- INFO -->
                                            <v-col class="my-2 pa-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="formMode !== 'New'">
                                                <h5 class="grey--text text--darken-1">INFO</h5>
                                                <v-divider class="" />
                                                <div class="caption grey--text text--darken-1 mt-2">
                                                    <strong>{{$t('fields.created')}}:</strong> {{ form.createdUserData.userName }} - {{ form.createdUserData.organisationName }} - {{ MIX_formatDateTime(form.createdDateTime, 'x', 'DD-MMM-YYYY') }} | 
                                                    <strong>{{$t('fields.modified')}}:</strong> {{ form.modifiedUserData.userName }} - {{ form.modifiedUserData.organisationName }} - {{ MIX_formatDateTime(form.modifiedDateTime, 'x', 'DD-MMM-YYYY') }}
                                                </div>                    
                                            </v-col> 
                                        </v-row>
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!-- HISTORY / COMMENTS -->
                            <v-tab-item value="history" class="pa-0">
                                <v-row class="mt-4 ma-0" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="ma-0 pl-2 pr-2">
                                            <!-- HISTORY DESCRIPTION (GENERIC) -->
                                            <v-col class="px-2 pl-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.history.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.history.text`) }}</app-text>                                                
                                                <v-divider class="my-4"/>
                                            </v-col>                      
                                            <!-- HISTORY / COMMENTS ACTION BAR (CUSTOM) -->                          
                                            <v-col cols="12" class="d-flex pa-0 pl-0 ml-0 mt-2 d-flex align-center">                                                
                                                <appbutton :label="$t('buttons.add')"  icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="MIX_comment({ show: true, action: 'New', data: { comment: '', private: true, docLink: { collection: 'documents', documentId: form.id } } })" />
                                                <v-spacer />
                                                <div class="font-weight-bold grey--text">ID</div>
                                                <v-switch v-model="showIDComments" class="ml-4 secondary--text" inset></v-switch>                                            
                                                <div class="font-weight-bold grey--text"><v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon></div>
                                                <v-switch @change="getComments(GET_openItem)" v-model="showDeletedComments" class="ml-4 secondary--text" inset></v-switch>                                            
                                            </v-col>
                                            <!-- HISTORY / COMMENTS DATA TABLE -->
                                            <v-col cols="12" class="pa-1 pl-1 mt-4 pr-2">
                                                <v-data-table
                                                    id="commentstable"
                                                    :headers="computedCommentsHeaders"
                                                    :items="computedCommentsTableData"
                                                    :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                                                    item-key="id"                                                   
                                                    class="elevation-0"
                                                    dense
                                                    hide-default-header
                                                    >
                                                        <!-- // STATUS -->
                                                        <template v-slot:[`item.concernStatus`]="{ item }">
                                                            <v-icon v-if="item.concernStatus === 'RESOLVED'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'ONHOLD'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-private"></v-icon>
                                                            <v-icon v-if="item.concernStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                                                        </template>
                                                        <!-- // HEADERS -->                        
                                                        <template v-slot:header="{ props }">
                                                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                                                {{ $t(`fields.${head.text}`) }}
                                                            </th>
                                                        </template>
                                                        <template v-slot:[`item.comment`]="{ item }">
                                                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="purple--text"><v-icon class="purple--text">icons8-trash</v-icon> {{ item.comment}}</span>
                                                            <span v-else>{{ item.comment }}</span>
                                                        </template>                                                    
                                                        <template v-slot:[`item.private`]="{ item }">
                                                            <v-icon v-if="item.private === true">icons8-lock</v-icon>
                                                            <v-icon v-if="item.private === false"></v-icon>
                                                        </template>
                                                        <!-- // DOC LINK -->
                                                        <template v-slot:[`item.docLink`]="{ item }">
                                                            {{ item.docLink.documentId }}
                                                        </template>
                                                        <!-- // CREATED USER DATA -->
                                                        <template v-slot:[`item.createdUserData`]="{ item }">
                                                            <div v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null" @click="MIX_popupUser(item.createdUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>      
                                                                {{ item.createdUserData.userName }}<br />
                                                                <span class="caption">{{ item.createdDateTime }}</span>
                                                            </div>
                                                        </template>                                                        
                                                        <!-- // MODIFIED USER DATA -->
                                                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                                                            <div v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null" @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>      
                                                                {{ item.modifiedUserData.userName }}
                                                                <span class="caption">{{ item.modifiedDateTime }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- // DELETE USER DATA -->
                                                        <template v-slot:[`item.deleteUserData`]="{ item }">
                                                            <div v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect fixedcolumn">
                                                                <v-icon>icons8-identification-documents</v-icon>      
                                                                {{ item.deleteUserData.userName }}
                                                                <span class="caption">{{ item.delete }}</span>
                                                            </div>
                                                        </template>
                                                        <!-- ACTIONS -->
                                                        <template v-slot:[`item.actions`]="{ item }">
                                                            <div class="actionscolumn">
                                                                <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="MIX_comment({ show: true, action: 'Edit', data: { id: item.id, comment: item.comment, private: item.private } })">icons8-edit-property</v-icon>
                                                                <v-icon v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" @click="MIX_undelete('comments', 'Comment', item.id)">icons8-process</v-icon>
                                                                <v-icon v-if="item.delete === null || item.delete === '' || item.delete === undefined" @click="deleteComment(item)">icons8-trash</v-icon>                                                        
                                                            </div>
                                                        </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters, mapState, mapActions  } from 'vuex'; // Map the Getters from the Vuex Store
import actions from '../old/actions.vue';
    export default {
  components: { actions },
        // * DATA
        data: () => ({
            // * PAGE DETAILS
            collection: 'documents',
            collectionTitle: 'Documents',
            collectionItem: 'document',
            collectionItemTitle: 'Document',
            langPath: 'project.projectPage.documents.document',
            tabs: 'viewer',
            // * FORM RELATED
            form: {
                documentName: '',
                documentType: '',
                documentStatus: 'PENDING',
                documentDescription: '',
                fileData: null,
                project: {
                    projectId: '',
                    projectName: '',
                    projectStatus: '',   
                }
            },
            rules: {},
            formMode: 'New', // Show Form in New Mode / Blank
            formReadOnly: false, // Make Form Editable
            formBackground: 'grey lighten-3',
            // * COMMENTS RELATED            
            commentsTableData: [],  // populated from firestore on show comments
            commentsHeaders: [
                { text: 'private',  value: 'private', align: 'center', sortable: false, hidden: false, hide: false },
                { text: 'id', value: 'id', align: 'start',  sortable: false, hidden: true, hide: false },
                { text: 'comment', value: 'comment', align: 'start', sortable: false, hidden: false, hide: false, },
                { text: 'docLink', value: 'docLink', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'createdUserData', value: 'createdUserData', align: 'start', sortable: false, hidden: false, hide: true },
                { text: 'created', value: 'createdDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'modified', value: 'modifiedDateTime', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'delete',   value: 'delete',  align: 'start',  sortable: false, hidden: true, hide: false },
                { text: 'deleteUserData', value: 'deleteUserData', align: 'start', sortable: false, hidden: true, hide: false },                                    
                { text: 'actions', value: 'actions', align: 'center', sortable: false, hidden: false, hide: false, width: '100px' },
            ],
            showDeletedComments: false, // Show Deleted Comments
            showIDComments: false,

            // * PROJECT RELATED
            formattedProjectStartDate: '', // holds the formated version of the Project Start Date
            formattedProjectEndDate: '', // holds the formated version of the Project End Date
            
            documentTypes: [], // Document Types
            documentStatus: [], // Status Options                      

            contractors: [], // Stores Contractors 

            // * CONTRACTOR MANAGERS / ADMIN
            contractorManagers: [],

            // DOCUMENT UPLOAD
            allowedTypes: "image/*, video/*, audio/*, text/*, .pdf, .PPT, .ppt, .PPTX, .pptx, .docx, .doc, .xls, .xlsx, .csv" ,
            folder: '',
        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
                GET_openItem: 'GET_openDocument', // Get Open Project Data
                GET_datePickerResult: 'datePicker_store/GET_datePickerResult', // Date Picker Results
                GET_docUploadResult: 'docUpload_store/GET_docUploadResult', // GET docUpload Result
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult',
                GET_panelLayout: 'GET_panelLayout', // Panel Layout used for Layout Structure
                GET_lookupValues: 'GET_lookupValues',
                GET_usersMA: 'GET_usersMA',
                GET_organisations: 'GET_organisations',
                GET_help: 'GET_help'
            }),
            // COMPUTED COMMENTS HEADERS (GENERIC)
            computedCommentsHeaders() {
                var t = this;
                var headers = t.commentsHeaders;
                var newHeaders = []
                for (var i = 0; i < headers.length; i++) {
                    var header = headers[i]
                    if (header.hidden) {
                        switch (true) {
                            // Add in Cases that need to be manually controlled
                            case (header.text === 'id'):
                                if (t.showIDComments) { newHeaders.push(header) } // remove if false
                                break;
                            case (header.text === 'deleteUserData'):
                                if (t.showDeletedComments) { newHeaders.push(header) } // remove if false
                                break;
                            default:
                                // do nothing
        
                        }
                    } else {
                        newHeaders.push(header)
                    }
                }
                return newHeaders
            }, 
            // COMPUTED COMMENTS TABLE DATA (GENERIC)
            computedCommentsTableData() {
                var t = this;
                var tableData = t.commentsTableData;
                var tableDataList = tableData.map(e => {
                    return {
                        private: e.private,
                        id: e.id,
                        comment: e.comment,
                        docLink: e.docLink,
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });
                return (tableDataList);      
            },                    
            // DOC LINK (GENERIC) - REQUIRED FOR DOCUMENT UPLOAD
            docLink() {
                var t = this;
                return ({ collection: t.collection, documentId: t.form.id })
            }
        },
        // * WATCH
        watch: {
             // GET CONFIRMATION RESULT (CUSTOM)
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === 'documents') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteDocumentResult = await t.MIX_deleteDocument ('documents', t.GET_confirmBoxResult.data.id);
                            var deleteLinkedResult = await t.MIX_deleteLinked (['files', 'comments'], t.GET_confirmBoxResult.data.id);
                            if ((deleteDocumentResult.code === 1) && (deleteLinkedResult.code === 1)) {
                                var comment = {}
                                comment.comment = `${t.collectionItemTitle} Deleted` 
                                comment.docLink = {},
                                comment.docLink.collection = 'documents';
                                comment.docLink.documentId = t.GET_confirmBoxResult.data.id;
                                comment.private = false;
                                await t.MIX_createDocument('comments', comment);
                                t.MIX_alert(1, `Document and File Deleted`, deleteDocumentResult.data, null);
                                t.refreshItemView();                            
                            } else {
                                t.MIX_alert(-1, `Error Deleting Document / File`, null, null);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'documents/destroy') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var destroyDocumentResult = await t.MIX_destroyDocument ('documents', t.GET_confirmBoxResult.data.id);
                            var destroyFileRecordResult = await t.MIX_destroyDocument ('files', t.form.fileData.id);
                                if ((destroyDocumentResult.code === 1) && (destroyFileRecordResult.code === 1)) {
                                t.MIX_alert(1, `Document and File Destroyed`, destroyDocumentResult.data, null);
                                t.MIX_setPanelLayout(12, 0, false, '', '');
                            } else {
                                t.MIX_alert(-1, `Error Deleting Document & File`, null, null);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'files') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteFileRecord = await t.MIX_destroyDocument('files', t.GET_confirmBoxResult.data.id);
                            if (deleteFileRecord.code === 1){
                                await t.MIX_updateDocumentFieldsById ('documents', t.form.id, { fileData: null } )
                                t.MIX_alert(1, `File Deleted`, deleteFileRecord.data, null);
                                setTimeout(function() {
                                    t.refreshItemView();                                      
                                    t.MIX_setPanelLayout(6, 6, true, 'Document', 'document');
                                }, 1000)
                            } else {
                                t.MIX_alert(-1, `ERROR Deleting Document & File`, null, deleteFileRecord.error);
                            }
                        }
                    } else if (t.GET_confirmBoxResult.data.collection === 'comments') {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, 'Comment Deleted', deleteResult.data, null);
                            } else {
                                t.MIX_alert(-1, 'Error Deleting Comment', null, deleteResult.error);
                            }
                        }                                    
                    } else {
                        // Do nothing
                    }
                }, deep: true
            },
            // * GET DOCUMENT UPLOAD RESULT
            GET_docUploadResult: {
                handler: async function() {
                    var t = this;
                    var docUploadResult = t.GET_docUploadResult;
                    if (JSON.stringify(docUploadResult) !== '{}') {
                        var updateDocumentResult = await t.MIX_updateDocumentFieldsById ('documents', t.form.id, { fileData: docUploadResult } )
                        if (updateDocumentResult.code === 1) {
                            t.MIX_createDocument('files', docUploadResult)
                            t.MIX_alert(1, 'Document Uploaded', updateDocumentResult.data, null);
                            setTimeout(function() {
                                t.refreshItemView();                                      
                                t.MIX_setPanelLayout(6, 6, true, 'Document', 'document');
                            }, 1000)

                        } else {
                            t.MIX_alert(-1, 'Error Uploading Document', null, updateDocumentResult.error);
                        }
                    }
                }, deep: true
            }
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openDocument'}),            
            // UPDATE BREADCRUMBS (CUSTOM)
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `Projects`, path: `/projects`}) // Set the Main Path
                breadcrumbs.push ({ name: `${t.form.project.projectName}`, path: `/projects/${t.form.project.projectId}/documents`}) // Set the Main Path
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/projects/${t.form.project.projectId}/documents`}) // Set the Main Path
                if (t.GET_openItem.process === 'New') {
                    breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
                } else {
                    breadcrumbs.push ({ name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`, path: `/projects/${t.form.project.projectId}/documents/${this.GET_openItem.data.id}`}) // Set a Secondary Path
                }
                this.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM (GENERIC)
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_openItem; // Get Open Item Data
                switch (openItem.process) {
                    case 'New': 
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.form = item.data; // Update the Form with the Open Item details            
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }              
                return;
            },
            // EDIT ITEM (GENERIC)
            editItem() {
                var t = this;
                t.formMode = 'Edit';
                t.formReadOnly = false;
                t.formBackground = 'white';
            },
            // CANCEL ITEM (GENERIC)
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.refreshItemView();     
                t.closeRightPanel();   
            },
              // CANCEL ITEM
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.removeUploadedDocument();
                t.refreshItemView();    
                t.closeRightPanel();  
            },
            // SAVE ITEM (GENERIC)
            saveItem: async function() {
                var t = this;
                if (t.form.id === undefined) {
                    t.form.id = t.MIX_generateId();  // if new then generate new id
                }

                var createDocumentResult = await t.MIX_createDocument(t.collection, t.form); // Create Document Within Firestore based on Form
                if (createDocumentResult.code === 1) {
                    if (t.formMode == 'New') {
                        // send notification to project manager
                        
                    }
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                    t.formReadOnly = true; // Set Form to Read Only
                    t.formBackground = 'grey lighten-3';
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },
            // * VALIDATION RULES
			validateForm() {
				let t = this;
                t.rules = {
                    documentName: [
                        v => !!v || 'Document Name is required',
                        v => (v && v.length < 255) || 'Name must be less than 255 characters',
                        v => (v && v !== ' ') || 'Name cannot be empty',
                    ],
                    documentType: [v => !!v || 'Type Required'],
                    documentStatus: [v => !!v || "Status Required"],
                    documentDescription: [
                        v => !!v || "Description Required",
                        v => (v && v !== ' ') || 'Description cannot be empty',
                    ],
                    site: [v => !!v || "Site Required"],
                    fileData: [v => !!v || 'File required'],
                    status: [v => !!v || 'Status required'],
                }
                //let the DOM update
                t.$nextTick(() => {
                    //manually trigger Vuetify validation
                    if(t.$refs.form.validate()) {     
                        this.saveItem();
                    } else {
                        t.MIX_alert(-1, "Please fill out all the fields", null, null);
                    }

                    //if not valid, errors will be automatically displayed
                })
			},
            // UPDATE ITEM STATUS (CUSTOM)
            updateItemStatus: async function(status) {
                var t = this;
                var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.form.id, { [t.collectionItem + 'Status']: status } )
                var comment = {}
                comment.comment = `${t.collectionItemTitle} ${t.MIX_lookupField(t.documentStatus, 'text', status)}` 
                comment.docLink = {},
                comment.docLink.collection = 'documents';
                comment.docLink.documentId = t.form.id;
                comment.private = false;
                await t.MIX_createDocument('comments', comment);
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error); 
                }
            },
            // REFRESH ITEM VIEW (GENERIC)
            refreshItemView: async function() {
                var t = this;
                var itemResult = await t.MIX_readDocumentById(t.collection, t.form.id)
                var payload = {}
                payload.process = 'View';
                payload.popup = false;
                payload.data = itemResult.data;
                t.ACT_openItem(payload);
                t.openItem();
            },
            // DELETE ITEM METHOD (GENERIC)
            deleteItem: function (id) {
                var t = this;
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: t.collection,
                        id: id,
                        title: `Delete ${t.collectionItemTitle}`, 
                        description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.form[t.collectionItem + 'Name']}</strong>?`, 
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
			// REMOVE UPLOADED DOCUMENT
			removeUploadedDocument() {
				this.$store.commit("upload_file_store/setFile", null);
			},
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            },
            // UNDELETE ITEM METHOD (CUSTOM)
            undeleteItem: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
                if (undeleteResult.code === 1) {
                    var unDeleteFileResult = await t.MIX_undeleteDocument ('files', t.form.fileData.id);
                    var unDeleteLinkedResult = await t.MIX_undeleteLinked (['files','comments'],  t.form.id)                    
                    if ((unDeleteFileResult.code === 1) && (unDeleteLinkedResult.code === 1)) {
                        var comment = {}
                        comment.comment = `${t.collectionItemTitle} Restored` 
                        comment.docLink = {},
                        comment.docLink.collection = 'documents';
                        comment.docLink.documentId = t.form.id;
                        comment.private = false;
                        await t.MIX_createDocument('comments', comment);
                        t.MIX_alert(1, `${t.collectionItemTitle} Restored`, unDeleteFileResult.data, null);
                        t.refreshItemView();                            
                    } else {
                        t.MIX_alert(-1, `Error Restoring File Record`, null, unDeleteFileResult.error);
                    }
                } else {
                    t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
                    // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
                }
                t.refreshItemView();
            },
            // DESTROY FILE METHOD (CUSTOM)
            destroyFile: async function () {
                var t = this
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: 'files',
                        id: t.form.fileData.id,
                        title: `Remove File`, 
                        description: `Are you sure you want to remove file: <br /><strong>${t.form.fileData.fileName}</strong>?`, 
                        width: '300',
                        height: '300',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )                               
            },
            // DESTROY ITEM METHOD (CUSTOM)
            destroyItem: async function() {
                var t = this
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: 'documents/destroy',
                        id: t.form.id,
                        title: `Destroy Document`, 
                        description: `Are you sure you want to destroy the document: <br /><strong>${t.form.documentName}</strong>?`, 
                        width: '300',
                        height: '300',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )     
            },
            // GET COMMENTS METHOD (GENERIC)
            getComments: async function (openItem) {
                var t = this;
                if (JSON.stringify(openItem.data) !== '{}') {
                    t.$firebase.db.collection('comments').where("docLink.documentId", "==", openItem.data.id)
                        .onSnapshot(function(querySnapshot) {
                            t.commentsTableData = [];
                            querySnapshot.forEach(function(doc) {
                                var document = doc.data()
                                document.id = doc.id;
                                if (!document.hasOwnProperty('delete')) {
                                    t.commentsTableData.push(document);
                                } else if (t.showDeletedComments) {
                                     t.commentsTableData.push(document);
                                } else {
                                    // Do not Show Notice
                                }
                            });
                    });
                }
            },
            // DELETE COMMENT METHOD (GENERIC)
            deleteComment: function (item) {
                this.MIX_confirmBox(
                    { 
                        show: true,
                        collection: 'comments',
                        id: item.id,
                        title: 'Delete Comment', 
                        description: `Are you sure you want to delete comment: <strong>${item.comment}</strong>?`, 
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },            
        },
        // * MOUNTED
        async mounted() {
            var t = this;
            // * LOOKUP RELATED MOUNTED
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            this.documentTypes = await this.GET_lookupValues('DOCUMENTTYPES');
            this.documentStatus = await this.GET_lookupValues('DOCUMENTSTATUS');


            // * OPEN ITEM (CUSTOM)
            var openItem = await t.GET_openItem; // Get Open Project Data
            // console.log('openItem = ' + JSON.stringify(openItem, null, 2))
            t.formMode = openItem.process; // Show Form in View Mode
            if (openItem.process === 'New') { 
                t.form.project.projectId = openItem.data.id;
                t.form.project.projectName = openItem.data.projectName;
                t.form.project.projectStatus = openItem.data.projectStatus;   
                t.form.projectManager = openItem.data.projectManager
                t.formReadOnly = false;             // Make Form Editable }
                t.formBackground = 'white';
                t.tabs = 'overview';
            } else {
                t.form = openItem.data; // Update the Form with the Open Project details    
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                if (openItem.data.fileData !== null) {
                    t.MIX_docViewer ({ fileType: openItem.data.fileData.fileType, fileURL: openItem.data.fileData.fileURL } )
                    t.tabs = 'viewer';
                } else {
                    t.tabs = 'overview';
                }
                t.getComments(openItem);
            }
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Titl
        }
    };
</script>

<style scoped>
    .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
    .v-tabs-items{
        width: 100% !important;
        height: 100% !important;
    }
    .v-window-item {
        height: calc(100vh - 170px); 
        overflow-y: auto;
    }
</style>
